import dashboard from './dashboard';
import pages from './pages';
import utils from './utils';
import offices from './office';
import quotations from './quotation';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, quotations, offices, utils],
};

export default menuItems;
